const propelInit = function() {
const navLinks = document.querySelectorAll(
	'.block-nav-link__button--with-submenu'
);

const toggleNavLink = (e) => {
	const currentNavLink = e.currentTarget;
	currentNavLink.parentElement.classList.toggle('active');

	if (currentNavLink.parentElement.classList.contains('active')) {
		navLinks.forEach((navLink) => {
			if (navLink === currentNavLink) {
				return;
			}

			navLink.parentElement.classList.remove('active');
			navLink.setAttribute('aria-expanded', false);
		});

		currentNavLink.setAttribute('aria-expanded', true);
	} else {
		currentNavLink.setAttribute('aria-expanded', false);
	}

	if (currentNavLink.parentElement.classList.contains('active')) {
		const openEvent = new CustomEvent('propel-nav-submenu-opened', {
			detail: { currentElement: currentNavLink },
		});

		window.dispatchEvent(openEvent);
	} else {
		const closeEvent = new CustomEvent('propel-nav-submenu-closed', {
			detail: { currentElement: currentNavLink },
		});

		window.dispatchEvent(closeEvent);
	}
};

const closeNavLinks = () => {
	if (0 === navLinks.length) {
		return;
	}

	navLinks.forEach((navLink) => {
		navLink.parentElement.classList.remove('active');
		navLink.setAttribute('aria-expanded', false);
	});

	const closeEvent = new CustomEvent('propel-nav-submenu-closed', {
		detail: { currentElement: navLinks[0] },
	});

	window.dispatchEvent(closeEvent);
};

navLinks.forEach((navLink) => {
	navLink.addEventListener('click', toggleNavLink);
});

window.addEventListener('propel-nav-opened', closeNavLinks);
window.addEventListener('propel-nav-closed', closeNavLinks);
window.addEventListener('propel-nav-search-opened', closeNavLinks);

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['nav-link'] = window.propel.blocks['nav-link'] || {};
window.propel.blocks['nav-link'].script = propelInit;
